import { render, staticRenderFns } from "./TrackingElected.vue?vue&type=template&id=58dd07f2"
import script from "./TrackingElected.vue?vue&type=script&lang=js"
export * from "./TrackingElected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports